import { ThemeProvider } from "@emotion/react";
import { GlobalStyleSheet } from "theme/global";
import theme from "theme/theme";
import moment from "moment";
import Router from "routes/router";

moment.locale("en");

const App = function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyleSheet />
      <Router />
    </ThemeProvider>
  );
};

export default App;
